"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationPasswordNotMatchingError = void 0;
class ConfirmationPasswordNotMatchingError extends Error {
    constructor() {
        super('New password and confirmation password not matching');
        this.key = 'CONFIRMATION_PASSWORD_NOT_MATCHING';
    }
}
exports.ConfirmationPasswordNotMatchingError = ConfirmationPasswordNotMatchingError;
//# sourceMappingURL=ConfirmationPasswordNotMatchingError.js.map